/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from "vue";
import VueAnalytics from "vue-analytics";
import Router from "vue-router";
import moment from "moment";
import store from "../store";

import Meta from "vue-meta";

const lessThanWeekAgo = (date) => {
    var weekAgo = moment()
        .subtract(2, "d")
        .format("L");

    return Date.parse(date) > Date.parse(weekAgo);
};

const isValidToken = (token) => {
    return lessThanWeekAgo(token);
};

const isMobile = (token) => {
    return (
        window.innerWidth < 551 &&
        location.href.startsWith("https://broadcast-b7a56.firebaseapp.com")
    );
};

const ifAuthenticated = (to, from, next) => {
    if (isValidToken(store.state.token) || to.path == "/login") {
        next();

        return;
    }

    next({
        path: "/login",
    });
};

// Routes
import paths from "./paths";
import state from "../store/state";

function route(path, view, name) {
    return {
        name: name || view,
        path,
        component: (resovle) => import(`@/views/${view}.vue`).then(resovle),
        beforeEnter: ifAuthenticated,
    };
}

Vue.use(Router);

// Create a new router
const router = new Router({
    mode: "history",
    routes: paths
        .map((path) => route(path.path, path.view, path.name))
        .concat([{ path: "*", redirect: "/messages-new" }]),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        if (to.hash) {
            return { selector: to.hash };
        }
        return { x: 0, y: 0 };
    },
});

Vue.use(Meta);

// Bootstrap Analytics
// Set in .env
// https://github.com/MatteoGabriele/vue-analytics
if (process.env.GOOGLE_ANALYTICS) {
    Vue.use(VueAnalytics, {
        id: process.env.GOOGLE_ANALYTICS,
        router,
        autoTracking: {
            page: process.env.NODE_ENV !== "development",
        },
    });
}

export default router;
